export enum LocalStorageKey {
  Language = 'language',
}
